// removed by extract-text-webpack-plugin
module.exports = {"block":"gAEmnF7XyshVH3bGeYhw4","heading":"qElo13ogQd25VTC707gyN","zebra":"_38sROKXuwY1YVWUkaY9Rr_","yellow":"_4WWGrjEvt5AY6AVY_1rYj","darkgray":"_70GX8UU531PyqcJ8N3-gR","lightgray":"_2tAvcQbPvj-TB4F-zIec1x","white":"_1anfP6Jdk6QBUiZS4pp8GX","content":"_2cF7XpAA1loN62TPSTlBAb","is-on-screen":"_2EJ6BrTQK_O9QIU-XmvxUK","see-all":"_3HH-stvjd_xlIz2c6lYzLG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/VacancyListBlock/VacancyListBlock.module.scss
// module id = 814
// module chunks = 0